import Configuration from '../../../../config/Configuration';
import Component from '../../../component/Component';
import React from 'react';
import { Timer } from '../../../../../utility/Timer';
import { Position } from '../../../../../index';
import { ACTIVITY_WARNING_STATE } from './Types';

const { SESSION_COUNTDOWN } = Configuration.get();

export class ActivityWarning extends Component<{}, ACTIVITY_WARNING_STATE> {
  private timer: any;

  state: ACTIVITY_WARNING_STATE = {
    timeLeft: SESSION_COUNTDOWN,
    staticTimeLeft: SESSION_COUNTDOWN
  };

  componentDidMount(): void {
    super.componentDidMount();
    this.setLogoutTimer();
  }

  /**
   * Sets logout timer which will show a warning dialog with countdown trigger
   */
  private setLogoutTimer = () => {
    this.timer = new Timer({
      onTimerChange: (timeLeft: number) => {
        this.setState({
          timeLeft
        });
      },
      onTimerFinish: () => this.dispatch('signOutLocalUserRequest', Position.end)
    });

    this.timer.start(SESSION_COUNTDOWN);
  };

  componentWillUnmount(): void {
    super.componentWillUnmount();
    // noinspection JSDeprecatedSymbols
    this.timer && this.timer.stop();
  }

  render() {
    let { timeLeft, staticTimeLeft } = this.state;

    return (
      <div>
        <span className={'sr-only'} aria-live={'polite'} role={'alert'}>
          {this.translate('text', {
            timeLeft: staticTimeLeft
          })}
        </span>
        <span aria-hidden={'true'}>
          {this.translate('text', {
            timeLeft
          })}
        </span>
      </div>
    );
  }
}
